<template>
  <section class="flex">

      <header class="container-1">
          <h1>Welcome to Li’l Yogis
</h1>
      
      <img src="../../assets/underline.png" alt="">

      <h4>At Lil Yogis we strongly believe that it’s never too early for yoga. <br> Making sure your kids come to the mat early will lead to a more <br> holistic development. When you sign them up, they’re not just <br> doing a physical activity, they’re absorbing a lifelong skillset. And <br>  what’s more, our experienced teachers focus on the students’ <br> total wellness and on developing a healthy lifestyle. </h4>
      <button>Get in Touch</button>
      </header>
      <div class="container-2">
      <img class="welcome" src="../../assets/welcome_img.png" alt="">
      </div>
  </section>

</template>

<script>
export default {

}
</script>

<style scoped>
.welcome{
        width: 100%;
    height: auto;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}

h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
.flex{
    display: flex;
    justify-content: space-evenly;
    padding-top: 12rem;
    width: 80%;
    margin: auto;
    flex-wrap: wrap;
}
.container-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
}
body{
    background: #FFFFF2;
}

@media (max-width: 1080px){
    .flex{
height: 1153px;
    }
    .container-1{
height: 631px;
    }
}

</style>>

